import React from 'react';
import { Layout } from 'antd';
import styled from 'styled-components';
import DropdownMenu from './DropdownMenu';

const { Header: AntHeader } = Layout;

const StyledHeader = styled(AntHeader)`
    display: flex;
    flex-wrap: wrap;
    background-color: ${props => props.theme.background.white};
    height: auto;
    flex-direction: column;
    padding: 0;
    align-items: center;
    border-top: 1px solid ${props => props.theme.background.border};
    position: sticky;
    top: 0;
    left: 0;
    margin: 50px 0;
`;

const LogoSection = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    position: relative;
    flex-wrap: wrap;

    .logo-img {
        margin-top: 25px;
        max-width: 500px;
    }

    @media (max-width: 800px) {
        .logo-img {
            max-width: 300px;
        }
    }

    @media (min-width: 1320px) {
        .logo-img {
            margin-top: 0;
        }
    }
`;

type Props = {
    guest: boolean;
};

const Header: React.FC<Props> = ({ guest }: Props) => (
    <StyledHeader>
        <LogoSection>
            <DropdownMenu guest={guest} />
        </LogoSection>
    </StyledHeader>
);

export default Header;
